/**
 * @constructor
 * @returns {ReelsEngine}
 */
export function ReelsEngine() {
	this._lastDelta = 16;

	this._time = 0;

	this._request = this._loop.bind(this);
	this._onLoop = function() {};
	this._stopped = true;
	this._paused = false;

	this._visibilityChangeBinded = this._visibilityChange.bind(this);
	document.addEventListener(window.visibilityChange, this._visibilityChangeBinded, false);
};

ReelsEngine.prototype.onLoop = function(func) {
	this._onLoop = func;
};

ReelsEngine.prototype._loop = function(time) {

	if(this._stopped || this._paused) {
		return;
	}

	this._raf = window.requestAnimationFrame(this._request);

	var delta = time - this._time;
	this._time = time;

	//if(delta > 100 || delta < 0) {
		//delta = this._lastDelta;

		/*if(delta < 15) {
			delta = 15;
		}*/
	//}

//	if(delta > 33) {
//		delta = 33;
//	}

	this._onLoop(delta);
	this._lastDelta = delta;

};

ReelsEngine.prototype.start = function() {

	if(!this._stopped) {
		return;
	}

	this._stopped = false;

	this._time = window.performance.now();

	this._raf = window.requestAnimationFrame(function() {
		this._loop(window.performance.now());
	}.bind(this));
};

ReelsEngine.prototype.stop = function() {
	this._stopped = true;
	window.cancelAnimationFrame(this._raf);
};

ReelsEngine.prototype._pause = function() {
	this._paused = true;
	this.stop();
};

ReelsEngine.prototype._play = function() {
	this._paused = false;
	this.start();
};

ReelsEngine.prototype._visibilityChange = function() {

	if (document[hidden]) {
		this._pause();
	} else {

		if(!this._paused) {
			return;
		}

		this._play();
	}
};

ReelsEngine.prototype.isRunning = function() {
	return !this._stopped;
};

ReelsEngine.prototype.destroy = function() {
	this.stop();
	document.removeEventListener(window.visibilityChange, this._visibilityChangeBinded);
};